import React from 'react';

const CustomMention = (props: any) => {
  return (
    <span style={{ color: '#05559C', fontSize: '14px', fontWeight: 'bold' }}>
      {props.children}
    </span>
  );
};

export default CustomMention;
